import * as ng from 'angular';

ng.module('e360')
   .directive('brightOrDark', brightOrDarkDirective);

/**
 * A directive that determines if a RGB value represents a _bright_ or _dark_
 * color and sets the class `bright` or `dark` on the element.
 * @usage <div bright-or-dark="{{some.color.value}}">...
 */
export function brightOrDarkDirective(): ng.IDirective {
   return {
      restrict: 'A',
      link: brightOrDarkLinkFn
   };
}

function brightOrDarkLinkFn(scope:ng.IScope, element:JQuery, attrs:ng.IAttributes) {
   // applies class once on link, could be adapted to watch expression instead
   let inputColor:string = attrs.brightOrDark;

   let rgb: number[] = [];

   inputColor = inputColor.replace('#', '');

   if (inputColor.length == 3 || inputColor.length == 6) {
      let digitSize = inputColor.length == 3 ? 1 : 2;

      for (var i = 0; i < (digitSize * 3); i += digitSize) {
         rgb.push(parseInt(inputColor.substr(i, digitSize), 16));
      }

      let hsl = getHSLForRGB(rgb);

      // input color is bright if (how close it is to white) is high and
      // the hue is low (the color is something like orange/yellow/green)
      if (hsl[0] <= 50 && hsl[2] >= 50) {
         element.addClass('bright');
      } else {
         element.addClass('dark');
      }
   }
}

/**
 * A function that returns the hue/saturation/lightness levels
 * from a given set of RGB values. Modified code take from:
 * https://codepen.io/pankajparashar/pen/oFzIg
 * @param rgb The red/green/blue values as an array
 * @returns the hsl values in percentages as an array
 */
function getHSLForRGB (rgb: number[]): number[] {
   let r = rgb[0] /= 255;
   let g = rgb[1] /= 255;
   let b = rgb[2] /= 255;

   let max = Math.max(r, g, b), min = Math.min(r, g, b);
   let h, s, l = (max + min) / 2;
   let result = [];

   if (max == min) {
      h = s = 0;
   } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max){
         case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
         case g:
            h = (b - r) / d + 2;
            break;
         case b:
            h = (r - g) / d + 4;
            break;
      }

      h /= 6;
   }

   result.push((h * 100 + 0.5) | 0);
   result.push((s * 100 + 0.5) | 0);
   result.push((l * 100 + 0.5) | 0);

   return result;
}
